import { ref, computed } from 'vue'

export const collapsed = ref(false)
export const toggleSidebar = () => (collapsed.value = !collapsed.value)

export const SIDEBAR_WIDTH = 220
export const SIDEBAR_WIDTH_COLLAPSED = 38
export const sidebarWidth = computed(
    () => `${collapsed.value ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH}px`
)

export const sidebarTitle = ref('MPOS')

export function setSidebarTitle(title) {
    sidebarTitle.value = title || 'MPOS'
}
export function resetSidebarTitle() {
    sidebarTitle.value = 'MPOS'
}